<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                show-search
                placeholder="请选择基地"
                allow-clear
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, queryDetail)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="queryDetail"
          />
        </div>
      </div>

      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @exportResource="exportBaseDetails"
          @addResourceCount="addResourceCount"
        />
      </div>
    </div>

    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => item.baseId + index"
        :scroll="{ x: 1200 }"
        class="table-pag"
        @change="changeCurrent"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottomAction"
          >
            <TableActions
              :actions="tableActions"
              :record="item"
              @config="handleConfig(item)"
              @changeLog="changeLog(item)"
              @checkDetail="checkDetail(record)"
              @delete="delLog(item)"
            />
          </a-row>
          <a-row>
            <TableActions
              class="action"
            /></a-row>
        </span>

        <template
          slot="baseName"
          slot-scope="text,record"
        >
          {{ record.baseName }}
        </template>

        <template
          slot="detailCheck"
          slot-scope="text,record"
        >
          <TableActions
            :actions="detailActions"
            @checkDetail="checkDetail(record)"
          />
        </template>

        <template
          slot="operateYear"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.operateYear }}
          </a-row>

          <a-row
            class="sum"
          >
            合计
          </a-row>
        </template>

        <template
          slot="contractAmount"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.contractAmount }}
          </a-row>
          <a-row
            class="sum"
          >
            {{ record.totalContractAmount }}
          </a-row>
        </template>

        <template
          slot="collectionAmount"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.collectionAmount }}
          </a-row>

          <a-row
            class="sum"
          >
            {{ record.totalCollectionAmount }}
          </a-row>
        </template>

        <template
          slot="availableAmount"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.availableAmount }}
          </a-row>

          <a-row
            class="sum"
          >
            {{ record.totalAvailableAmount }}
          </a-row>
        </template>

        <template
          slot="distributionAmount"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.distributionAmount }}
          </a-row>

          <a-row
            class="sum"
          >
            {{ record.totalDistributionAmount }}
          </a-row>
        </template>

        <template
          slot="remainAmount"
          slot-scope="text,record"
        >
          <a-row
            v-for="(item,index) in record.data"
            :key="index"
            class="bottom"
          >
            {{ item.remainAmount }}
          </a-row>

          <a-row
            class="sum"
          >
            {{ record.totalRemainAmount }}
          </a-row>
        </template>
      </a-table>
    </div>
    <configureResourcesModal
      :init-data="initData"
      :collection-amount="collectionAmount"
      :visible="modalVisible"
      :loading="confirmLoading"
      :product-typetions="productTypetions"
      :contract-id="contractId"
      @cancel="handleCancel"
      @ok="handleOk"
    />
    <checkDetailModal
      :visible="checkVisible"
      :detail-data="detailData"
      :loading="confirmLoading"
      @cancel="handleCancel"
    />

    <AddContract
      :add-init-data="addInitData"
      :visible="addContractVisible"
      :loading="confirmLoading"
      :base-options="baseOptions"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import ConfigureResourcesModal from './configureResourcesModal.vue'
import checkDetailModal from './checkDetail.vue'

import { queryBaseResources, queryResourcePack, queryResourceChange, exportBaseDetails } from '@/api/resourceSetting.js'
import {
  queryBases,
  queryAllProductTypes
} from '@/api/common.js'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'
import AddContract from './AddContract.vue'
import { deleteContract } from '@/api/contractInfo.js'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]

const addActions = [{
  title: '添加运营年度汇总',
  type: 'primary',
  action: 'addResourceCount',
  apis: ['@baseInfo/Export_Bases']
},
{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  apis: ['@baseInfo/Export_Bases'],
  ghost: true
}]

const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '150px',
    scopedSlots: { customRender: 'baseName' }
  },
  {
    title: '运营年度',
    dataIndex: 'operateYear',
    key: 'operateYear',
    scopedSlots: { customRender: 'operateYear' }
  },
  {
    title: '应回款额',
    dataIndex: 'contractAmount',
    key: 'contractAmount',
    scopedSlots: { customRender: 'contractAmount' }
  },
  {
    title: '已回款额',
    dataIndex: 'collectionAmount',
    key: 'collectionAmount',
    scopedSlots: { customRender: 'collectionAmount' }
  },
  {
    title: '可发资源总额',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    scopedSlots: { customRender: 'availableAmount' }
  },
  {
    title: '已发资源总额',
    dataIndex: 'distributionAmount',
    key: 'distributionAmount',
    scopedSlots: { customRender: 'distributionAmount' }
  },
  {
    title: '剩余资源总额',
    dataIndex: 'remainAmount',
    key: 'remainAmount',
    scopedSlots: { customRender: 'remainAmount' }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '230px',
    scopedSlots: { customRender: 'actions' },
    align: 'center'
  },
  {
    title: '详情',
    dataIndex: 'detailCheck',
    key: 'detailCheck',
    width: '150px',
    scopedSlots: { customRender: 'detailCheck' },
    align: 'center'
  }
]
const tableActions = [
  {
    title: '配置资源',
    type: 'link',
    action: 'config',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '变更记录',
    type: 'link',
    action: 'changeLog'
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete'
  }
]

const detailActions = [
  {
    title: '查看详情',
    type: 'link',
    action: 'checkDetail'
  }
]

export default {
  components: {
    ConfigureResourcesModal,
    checkDetailModal,
    AddContract
  },
  data () {
    return {
      addActions,
      headerActions,
      detailActions,
      columns,
      dataSource: [],
      loading: false,
      pagination: {
        ...pagination,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      baseOptions: [],
      tableActions,
      modalVisible: false,
      checkVisible: false,
      confirmLoading: false,
      initData: null,
      detailData: null,
      dataSourceTempt: [],
      productTypetions: [],
      collectionAmount: null,
      form: {
        baseId: undefined
      },
      contractId: undefined,
      formType: this.$route.query.type,
      addContractVisible: false,
      addInitData: null,
      isCheck: 0
    }
  },
  created () {
    // this.loading = true
    if (this.$route.query.isCheck === '1') {
      this.form.baseId = this.$route.query.id
    }
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    changeCurrent (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })
    },

    async fetchData () {
      this.loading = true
      await queryBaseResources({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        baseId: this.form.baseId
      }).then((data) => {
        this.dataSource = []
        this.dataSourceTempt = data.result ? data.result : []
        this.dataSourceTempt.map((item) => {
          this.dataSource.push(item)
        })
        this.pagination.total = data.totalRecords
      })

      this.loading = false
    },
    queryDetail () {
      this.pagination.current = 1
      if (this.form.baseId) {
        this.isCheck = 1
      }
      this.fetchData()
    },
    addPaymentRecord () {
      this.modalVisible = true
    },
    async handleConfig (record) {
      await queryResourcePack({
        contractId: record.contractId
      }).then((data) => {
        this.initData = data
        this.collectionAmount = Number(record.collectionAmount)
        this.modalVisible = true
        this.contractId = record.contractId
      })
    },
    handleCancel () {
      this.modalVisible = false
      this.checkVisible = false
      this.addContractVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    checkDetail (record) {
      this.$router.push(`/admin/resource/setting/detailSetting?id=${record.baseId}&isCheck=${this.isCheck}`)
    },
    delLog (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteContract({
            contractId: record.contractId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    async changeLog (record) {
      this.loading = true
      await queryResourceChange({
        contractId: record.contractId
      }).then((data) => {
        this.detailData = data
      })
      this.loading = false
      this.checkVisible = true
    },
    async exportBaseDetails () {
      await exportBaseDetails({
        baseId: this.form.baseId
      }).then((data) => {
        this.excelDown(data, '运营年度配置')
      })
    },
    addResourceCount () {
      this.addInitData = {
        baseId: undefined,
        contractAmount: undefined,
        operateYear: undefined
      }

      this.addContractVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 20px;
}

.bottom {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  height: 62px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sum {
  padding: 20px;
  height: 62px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.bottomAction {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  height: 61px;
}

.action {
  // border-bottom: 1px solid #e8e8e8;
  padding: 20px;
  visibility: hidden;
  display: block;
  height: 61px;
}

/deep/ .ant-table-tbody > tr > td:not(:first-child) {
  padding: 0;
}
</style>
